import React, { FC, memo } from 'react';
import { createUseStyles } from 'react-jss';
import colors from '@packages/core/styles/colors';
import StsLogo from '@packages/ui/assets/images/techshare-logo-white.svg?react';
import SubaruLogo from '@packages/ui/assets/images/white-subaru-logo.png';

const useStyles = createUseStyles({
    header: {
        backgroundColor: colors.blueOne,
        color: colors.white,
        height: 80,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        textAlign: 'center',
        padding: '32px',
        '@media print': {
            display: 'flex',
        },
    },
    logoContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        height: 32,
        width: 120,
        objectFit: 'contain',
    },
});

export const BmisPDFHeader: FC = memo(() => {
    const classes = useStyles();

    return (
        <div className={classes.header}>
            <div className={classes.logoContainer}>
                <StsLogo className={classes.logo} />
            </div>
            <div className={classes.logoContainer}>
                <img src={SubaruLogo} alt="Subaru Logo" className={classes.logo} />
            </div>
        </div>
    );
});
